import './Rodape.css'

const Rodape = () => {
    return (
        <header className='rodape'>
            <img src="/imagens/rodape.png" alt="O rodapé da página Little Jungle" />
        </header>
    )
}

export default Rodape